<template>
	<div class="store-basic-info">
		<div class="fx-header">
			<p>可售商品库</p>
		</div>
		<Search :freightType='freightType' :page="params.page" :size="params.size" :showFlag="showFlag" @getTableData="getTableDataHandle" @getParamsData="getParamsData" ref="search"></Search>
		<div class="features-btn-box">
			<div style="display:flex;">
				<el-button type="primary" v-if='AuthorityList["02_0001_0002_00"] && !matchbillcenterflag' size='small' class="fx-big-btn" plain @click="addClick">新建</el-button>
				<el-button type="primary" v-if='AuthorityList["02_0001_0003_00"]' size='small' class="fx-big-btn" plain @click="deleteList">删除</el-button>
				<el-button type="primary" v-if='AuthorityList["02_0001_0008_00"]' size='small' class="fx-big-btn" plain @click="startStatus">启用状态</el-button>
				<el-button type="primary" v-if='AuthorityList["02_0001_0009_00"]' size='small' class="fx-big-btn" plain @click="privateStatus">私密状态</el-button>
				<el-button type="primary" v-if='AuthorityList["02_0001_0007_00"]' size='small' class="fx-big-btn" plain @click="batchSetting">批量设置</el-button>
				<el-button v-if="tempflag === 4" type="primary" size='small' class="fx-big-btn" plain @click="getOldData">商品档案处理</el-button>
				<div v-if="AuthorityList['02_0001_0005_00'] && !matchbillcenterflag" class="batch-register-btn" @click="importExcel">
					<i class="excel-icon export-excel-icon"/>
					<span>导入</span>
				</div>
				<div v-if="AuthorityList['02_0001_0006_00']" class="batch-register-btn" @click="exportExcel">
					<i class="excel-icon export-excel-icon"/>
					<span>导出</span>
				</div>
				<div class="batch-register-btn" @click="downloadFile">
					<i class="excel-icon export-excel-icon"/>
					<span>下载更新价格模板</span>
					<a :href="downloadUrl" ref="download" v-show="false"></a>
				</div>
				<div v-if="AuthorityList['02_0001_0005_00']" class="batch-register-btn" @click="importPriceExcel">
					<i class="excel-icon export-excel-icon"/>
					<span>更新商品销售价格</span>
				</div>
				<div v-if="AuthorityList['02_0001_0005_00']" class="batch-register-btn" @click="openBatchImportImg">
					<i class="excel-icon export-excel-icon"/>
					<span>批量导入商品图片</span>
				</div>
				<input type="file" ref="file" id="file" accept=".xls,.xlsx" v-show="false" @change="getFile">
			</div>
			<div style="display: flex;align-items: center;">
				<el-button type="primary" v-if='AuthorityList["02_0001_0002_00"]' size='small' class="fx-big-btn" plain @click="addPackageClick">创建组合商品</el-button>
				<div style="position: relative;margin-left: 10px;">
					<div v-if="showSetting" class="setting-box" :style="'height: ' + tableBoxHeight + 'px'">
						<div class="setting-title-box">
							<div>
								<el-checkbox v-model="allShow" @change="allShowChange">列展示</el-checkbox>
							</div>
							<div style="color: var(--fx-primary-color);">
								<span style="cursor: pointer;" @click="saveTable">保存</span>
								<span> | </span>
								<span style="cursor: pointer;" @click="clearTable">重置</span>
							</div>
						</div>
						<div class="setting-container-box">
							<vuedraggable v-model="tableTitle" @end='reloadTableData'>
								<div v-for="item in tableTitle" v-show="(item.name === 'sbcname' && bigcategoryview === 1) || (item.name === 'unit' && !matchbillcenterflag) || (item.name === 'intervalCostPrice' && costshowflag === 1) || (item.name !== 'sbcname' && item.name !== 'unit' && item.name !== 'intervalCostPrice')" :key='item.name' class="setting-row">
									<img src="~/images/icon/yidongshu.png" alt="" style="margin-right:15px"/>
									<el-checkbox v-model="item.isChoose" @change="checkAll">{{item.text}}</el-checkbox>
								</div>
							</vuedraggable>
						</div>
					</div>
					<i class="el-icon-s-tools" style="font-size: 30px;color:var(--fx-primary-color);cursor: pointer;" @click="showSettingChange"></i>
				</div>
			</div>
		</div>
		<div class="table-div" ref="tableBox">
			<el-table
				:stripe='false'
				class="grid-content goods-table"
				:data="tableData"
				size='mini'
				@row-dblclick='rowClick'
				:height="tableHeight"
				border
				ref="table"
				:row-class-name="tableRowClassName"
				@sort-change='sortChangeHandle'
				@select="handleSelectionChange"
				:key="isUpdate"
				@select-all="handleSelectionChange">
				<el-table-column
				type="selection"
				align="center"
				width="55">
				</el-table-column>
				<el-table-column key="url" prop="url" label="商品信息" sortable="custom" align="center" min-width="300" :render-header="renderHeader">
					<template slot-scope="scope">
						<div class="goods-table-info">
							<div class="goods-table-fold"><span class="showFlag"
									@click="showFold(scope.$index)">{{scope.row.showFlag ? '-' : '+'}}</span></div>
							<img v-if="scope.row.url === ''" src="~/images/img/no-goods-img.png"
								style="width: 80px; height:80px">
							<w-image v-else :src="scope.row.url" style="width: 80px;height:80px"></w-image>
							<div class="goods-table-name">{{scope.row.productname}}</div>
						</div>
					</template>
				</el-table-column>
				<template v-for="item in showTableTitle">
					<el-table-column :key="item.name" v-if="item.name === 'bbcname'" prop="bbcname" label="店铺级大类" align="center" sortable="custom" min-width="180">
					</el-table-column>
					<el-table-column :key="item.name" v-if="bigcategoryview === 1 && item.name === 'sbcname'" prop="sbcname" label="店铺级小类" align="center" sortable="custom"
						min-width="180">
					</el-table-column>
					<el-table-column :key="item.name" v-if="item.name === 'showflag'" prop="showflag" label="未登录时是否显示" align="center" min-width="180">
						<template slot-scope="scope">
							{{scope.row.showflag === 1 ? '显示' : '不显示'}}
						</template>
					</el-table-column>
					<el-table-column :key="item.name" v-if="item.name === 'shopNames'" label="适用门店" align="center" min-width="150">
						<template slot-scope="scope">
							<div v-if="scope.row.relAllShopFlag === 1">全部门店</div>
							<el-tooltip v-else class="item" effect="dark" :content="scope.row.shopNames" placement="top">
								<div>{{scope.row.shopCount}}家</div>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column :key="item.name" v-if="item.name === 'productcode'" prop="productcode" label="商品/规格" align="center" min-width="240">
						<template slot-scope="scope">
							<div class="goods-table-spec goods-table-spec2">
								<div class="spec-blue" v-if="scope.row.matchCode">三方：{{scope.row.matchCode}}</div>
								<div class="spec-blue" :class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''"
									@mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">
									<span>{{scope.row.producttype ? '组合' : '商品'}}</span>{{scope.row.productcode}}</div>
								<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag"
									:class="item.bold ? 'spec-bold' : item.bold2 ? 'spec-bold':''"
									@mouseover="specEnter(scope.$index, index)" @mouseout="specOut(scope.$index, index)">
									<span>规格</span>{{item.code}}<img src="~/images/icon/goods-spec.png" class="" v-if="item.url"
										@click="lookSpecImg(item.url)"></div>
							</div>
						</template>
					</el-table-column>
					<el-table-column :key="item.name" v-if="item.name === 'unit' && !matchbillcenterflag" label="单位" align="center" min-width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.useunitflag === 1" class="goods-table-spec goods-table-spec2">
								<div style="text-align: center;">{{scope.row.unit.baseUnitName}}</div>
								<div style="text-align: center;">
									{{scope.row.unit.assistUintName}}({{scope.row.unit.ratio + scope.row.unit.baseUnitName}})</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column :key="item.name" v-if="item.name === 'code'" prop="code" label="规格名称" align="center" min-width="180">
						<template slot-scope="scope">
							<div class="goods-table-spec">
								<div></div>
								<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag"
									:class="item.bold ? 'spec-bold' : item.bold2 ? 'spec-bold':''"
									@mouseover="specEnter(scope.$index, index)" @mouseout="specOut(scope.$index, index)">{{item.spec}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column :key="item.name" v-if="item.name === 'price'" prop="price" label="销售价" align="center" sortable="custom" min-width="180">
						<template slot-scope="scope">
							<div class="goods-table-spec">
								<div :class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''"
									@mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">
									{{formateIntervalPrice(scope.row.intervalPrice)}}</div>
								<div v-if="scope.row.spec.length === 1 && !scope.row.producttype">
									<el-input v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag"
										:class="item.bold ? 'spec-bold' : item.bold2 ? 'spec-bold':''" @change="priceChange(item)"
										@input='checkPrice(item,"price")' @blur="priceChangeSubmit(item, scope.row)" size="mini"
										class="no-icon" v-model="item.price"></el-input>
								</div>
								<div v-for="(item, index) in scope.row.spec" v-else :key="index" v-show="scope.row.showFlag"
									:class="item.bold ? 'spec-bold' : item.bold2 ? 'spec-bold':''"
									@mouseover="specEnter(scope.$index, index)" @mouseout="specOut(scope.$index, index)">{{item.price}}
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column :key="item.name" v-if="item.name === 'intervalCostPrice' && costshowflag === 1" prop="intervalCostPrice" label="成本价" align="center"
						sortable="custom" min-width="180">
						<template slot-scope="scope">
							<div class="goods-table-spec">
								<div :class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''"
									@mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">
									{{formateIntervalPrice(scope.row.intervalCostPrice)}}</div>
								<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag"
									:class="item.bold ? 'spec-bold' : item.bold2 ? 'spec-bold':''"
									@mouseover="specEnter(scope.$index, index)" @mouseout="specOut(scope.$index, index)">{{item.costprice}}
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column :key="item.name" v-if="item.name === 'disabledflag'" prop="disabledflag" label="启用状态" align="center" min-width="110">
						<template slot-scope='scope'>
							<div class="goods-table-qita">
								<div v-if='scope.row.disabledflag === false'
									:class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''"
									@mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">启用</div>
								<div v-if='scope.row.disabledflag === true'
									:class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''"
									@mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">禁用</div>
								<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag"></div>
							</div>
						</template>
					</el-table-column>
					<el-table-column :key="item.name" v-if="item.name === 'hiddenflag'" prop="hiddenflag" label="私密状态" align="center" min-width="110">
						<template slot-scope='scope'>
							<div class="goods-table-qita">
								<div v-if='scope.row.hiddenflag === false'
									:class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''"
									@mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">公开</div>
								<div v-if='scope.row.hiddenflag === true'
									:class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''"
									@mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">私密</div>
								<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag"></div>
							</div>
						</template>
					</el-table-column>
					<el-table-column :key="item.name" v-if="item.name === 'visibleflag'" prop="visibleflag" label="是否可见" align="center" min-width="180">
						<template slot-scope="scope">
							{{scope.row.visibleflag ? '可见' : '不可见'}}
						</template>
					</el-table-column>
				</template>
				<el-table-column label="操作" width="160" align="center">
					<template slot-scope="scope">
						<el-button v-if='AuthorityList["02_0001_0004_00"]' type='text' size="small" icon="el-icon-search" @click="getDetail(scope.row)">查看</el-button>
						<el-button type='text' size="small" v-if="!matchbillcenterflag || (matchbillcenterflag && scope.row.producttype)" @click="copyClick(scope.row)">复制</el-button>
						<el-button @click="deleteClick(scope.row)" v-if='AuthorityList["02_0001_0003_00"] && !matchbillcenterflag' type='text' size="small" icon="el-icon-delete">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="params.page"
				:page-sizes="[20, 40, 60, 100, 300]"
				:page-size="params.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
			<el-dialog title="添加商品" top='60px' :before-close="cancelClick" class="dialog-title" :visible.sync="bindModal" width='1000px' :close-on-click-modal="false">
				<bindModal ref='bindModal' :isShow.sync='isShow' :sessionStoreId='params.shopid' :dialogVisible.sync='bindModal' :isCheckFlag='isCheck' @cancel='cancel'></bindModal>
			</el-dialog>
			<el-dialog :title="'启用状态 (已勾选' + ids.length + '个商品)'" :before-close="startClose" class="dialog-title" :visible.sync="startModal" width='400px' :close-on-click-modal="false">
				<div>
					<el-radio v-model="startRadio" :label="0" class="radio-box">启用</el-radio>
					<el-radio v-model="startRadio" :label="1" class="radio-box">禁用</el-radio>
					<div class="title-btn-box">
						<el-button class="btn" plain type="primary" size='small' @click="startClose">取消</el-button>
						<el-button class="btn" plain type="primary" size='small' @click="startSave">确认</el-button>
					</div>
				</div>
			</el-dialog>
			<el-dialog :title="'私密状态 (已勾选' + ids.length + '个商品)'" :before-close="privateClose" class="dialog-title" :visible.sync="privateModal" width='400px' :close-on-click-modal="false">
				<div>
					<el-radio v-model="privateRadio" :label="0" class="radio-box">公开</el-radio>
					<el-radio v-model="privateRadio" :label="1" class="radio-box">私密</el-radio>
					<div class="title-btn-box">
						<el-button class="btn" plain type="primary" size='small' @click="privateClose">取消</el-button>
						<el-button class="btn" plain type="primary" size='small' @click="privateSave">确认</el-button>
					</div>
				</div>
			</el-dialog>
			<el-dialog title="查看图片" class="dialog-title" :visible.sync="showImgModal" width='400px' :close-on-click-modal="false">
				<div style="text-align:center;"><w-image :src="specImg" style="width: 200px; height:200px;display:inline-block;"></w-image></div>
			</el-dialog>
			<el-dialog title="批量设置可售商品库存" top='60px' :before-close="cancelSetMuit" class="dialog-title" :visible.sync="showSetMuit" width='1350px' :close-on-click-modal="false">
				<setMuti :show.sync='showSetMuit' :sessionStoreId='params.shopid'></setMuti>
			</el-dialog>
			<el-dialog top='60px' class="detail-dialog-title" :visible.sync="detailModal" width='1000px' :before-close="isClose" :close-on-click-modal="false">
				<ViewModal ref="viewModal" :visible.sync='detailModal' @isClose='isClose' :goodsId='goodsId' :productId='productId' v-if="detailModal" :showBtn='showBtn'></ViewModal>
			</el-dialog>
			<el-dialog title="批量设置副标题" top='60px' class="dialog-title" :visible.sync="showSetTitle" width='1000px' :close-on-click-modal="false">
				<div class="setTitle-box">
					<div class="title-select-box">
						<div>
							<div class="">选中设副标题：</div>
							<el-input size='mini' class="title-input" :maxlength='100'  @change="subtitleChange" v-model="subtitle" placeholder="限100字符内，支持中英文数字特殊符号"></el-input>
							<el-button style="margin-left:10px" size='mini' @click="mutiSave" type='primary' plain>确定</el-button>
						</div>
						<div>
							<div class="">选中颜色：</div>
							<el-color-picker size='mini' @change="subtitlecolourChange" :predefine="predefineColors" v-model="subtitlecolour"></el-color-picker>
						</div>
					</div>
					<div class="title-table-box">
						<el-table
							:stripe='true'
							class="grid-content"
							:data="titleTableData"
							size='mini'
							:height="tableHeight"
							border
							:cell-class-name="addCellClass"
							@selection-change="handleSelectionTitleChange">
							<el-table-column
							type="selection"
							align="center"
							width="55">
							</el-table-column>
							<el-table-column
								label-class-name = "column-index"
								label="序号"
								type="index"
								width="70"
								align="center">
							</el-table-column>
							<el-table-column
								prop="productname"
								:show-overflow-tooltip='true'
								label="商品名称"
								align="center"
								width="180">
							</el-table-column>
							<el-table-column
								label="副标题"
								align="center"
								min-width="180">
								<template slot-scope='scope'>
									<el-input size='mini' class="title-input" :maxlength='100' v-model="scope.row.subtitle"  @change="subtitleChange1(scope.row)" placeholder="限100字符内，支持中英文数字特殊符号"></el-input>
									<el-color-picker size='mini' :predefine="predefineColors" v-model="scope.row.subtitlecolour" @change="subtitlecolourChange1(scope.row)"></el-color-picker>
								</template>
							</el-table-column>
							<el-table-column
								label="操作"
								align="center"
								width="100">
								<template slot-scope='scope'>
									<div class="btn-box" @click="delClick(scope.$index)">
										<img src="~/images/icon/del-icon.png" alt="">移除
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="title-btn-box">
						<el-button class="btn" plain type="primary" size='small' @click="titleCancel">取消</el-button>
						<el-button class="btn" plain type="primary" size='small' @click="titleSave">保 存</el-button>
					</div>
				</div>
			</el-dialog>
			<el-dialog :title="'批量设置 (已选择' + ids.length + '个商品)'" :before-close="cancelBatchSetting" class="dialog-title" :visible.sync="showBatchSetting" width='1000px' :close-on-click-modal="false">
				<el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="form-box" v-if="showBatchSetting">
					<div class="batchSetBox">
						<div class="input-box">
							<span>字段名：</span>
							<el-select v-model="ruleForm.word" class="filter-input" size='small' @change="wordChange">
								<el-option value="1" label="快速设置店铺级分类"></el-option>
								<el-option value="2" label="快速设置商品顺序号"></el-option>
								<!-- <el-option v-if="freightType !== 1 && !stopFlag" value="4" label="快速设置运费"></el-option> -->
								<el-option v-if="!matchbillcenterflag" value="3" label="适用门店"></el-option>
								<el-option v-if="!matchbillcenterflag" value="5" label="设置辅助单位换算系数"></el-option>
								<el-option value="6" label="可见状态"></el-option>
								<el-option value="7" label="未登录时是否显示"></el-option>
								<el-option value="8" label="快速设置运输方式"></el-option>
							</el-select>
						</div>
						<div v-show="ruleForm.word === '1'">
							<div class="input-box">
								<span>店铺级大类：</span>
								<el-select v-model="ruleForm.bigTypeCategory" class="filter-input" placeholder="请选择店铺级大类" size='small' @change="bigCategoryChange('ruleForm')">
									<template v-for="(item) in bigCategoryList">
										<el-option
											:value="item.bc_id"
											:label="item.bc_name"
											:key="item.bc_id"
											:disabled="item.disabledflag"/>
								</template>
								</el-select>
							</div>
							<div class="input-box" v-if="bigcategoryview === 1">
								<span>店铺级小类：</span>
								<el-select v-model="ruleForm.smallTypeCategory" class="filter-input" placeholder="请选择店铺级小类" size='small' @change="smallCategoryChange('ruleForm')">
									<template v-for="(item) in smallCategoryList">
										<el-option
											:key="item.id"
											:label="item.name"
											:value="item.id"
											:disabled="item.disabledflag">
										</el-option>
									</template>
								</el-select>
							</div>
							<div class="input-box" v-if="thirdCategoryEnabled">
								<span>三级小类：</span>
								<el-select ref="thirdCategorySelect" v-model="ruleForm.thirdTypeCategory" class="filter-input" placeholder="请选择三级小类" size='small' clearable @visible-change="thirdCategoryVisibleChange">
									<template v-for="(item) in thirdCategoryList">
										<el-option
											:key="item.id"
											:label="item.name"
											:value="item.id"
											:disabled="item.disabledflag">
										</el-option>
									</template>
								</el-select>
							</div>
							<div class="title-btn-box">
								<el-button class="btn" plain type="primary" size='small' @click="saveBatchSetting">确认</el-button>
							</div>
						</div>
						<div class="table-box-sort" v-show="ruleForm.word === '2'">
							<el-table
								:stripe='true'
								size='mini'
								ref='multipleTable'
								class="grid-content"
								:data="seqnumTable"
								max-height='400'
								border>
									<el-table-column
										label-class-name = "column-index"
										label="序号"
										type="index"
										width="70"
										align="center">
									</el-table-column>
									<el-table-column
										prop="productname"
										label="商品名称"
										align="center"
										min-width="180">
									</el-table-column>
									<el-table-column
										prop="productcode"
										label="商品编号"
										align="center"
										min-width="160">
									</el-table-column>
									<el-table-column
										prop="seqnum"
										label="商品顺序号"
										sortable
										align="center"
										min-width="100">
										<template slot-scope="scope">
											<el-input
												class="num-input"
												v-model="scope.row.seqnum"
												size="small"
												@input="numInput(scope.row)"
												@blur="numBlur(scope.row)"
											></el-input>
										</template>
									</el-table-column>
									<el-table-column
									prop="disabledflag"
									label="启用状态"
									align="center"
									min-width="100">
									<template slot-scope="scope">{{ scope.row.disabledflag ? '禁用' : '启用' }}</template>
									</el-table-column>
									<el-table-column
										prop="bbcname"
										label="店铺级大类"
										align="center"
										min-width="100">
										<template slot-scope="scope">
											<el-select v-model="scope.row.bigTypeCategory" class="filter-input" placeholder="请选择店铺级大类" size='small' @change="seqBigCategoryChange(scope.row)">
												<template v-for="(item) in scope.row.bigCategoriesList">
													<el-option
														:value="item.bc_id"
														:label="item.bc_name"
														:key="item.bc_id"
														v-if="!item.disabledflag"/>
												</template>
											</el-select>
										</template>
									</el-table-column>
									<el-table-column
										v-if="bigcategoryview === 1"
										prop="sbcname"
										label="店铺级小类"
										align="center"
										min-width="100">
										<template slot-scope="scope">
											<el-select v-model="scope.row.smallTypeCategory" class="filter-input" placeholder="请选择店铺级小类" size='small'>
												<template v-for="(item) in scope.row.smallCategoriesList">
													<el-option
														:key="item.id"
														:label="item.name"
														:value="item.id"
														v-if="!item.disabledflag">
													</el-option>
												</template>
											</el-select>
										</template>
									</el-table-column>
							</el-table>
							<div class="title-btn-box">
								<el-button class="btn" plain type="primary" size='small' @click="saveSecSetting">确认</el-button>
							</div>
						</div>
						<div v-if="ruleForm.word === '4'">
							<Freight :spceList='spceList' @saveFreight='saveFreight' @cancelFreight='cancelFreight' :orginData='orginData'></Freight>
						</div>
						<div v-show="ruleForm.word === '3'" style="margin: 10px 20px;">
							<div style="display: flex;align-items: center;height: 40px;">
								<div style="width:90px;text-align: right;">
									适用门店：
								</div>
								<el-radio style="height: 20px;line-height: 20px;" v-model="relAllShopFlag" :label="1">全部门店</el-radio>
								<el-radio style="height: 20px;line-height: 20px;" v-model="relAllShopFlag" :label="0">自定义门店</el-radio>
								<div  v-if="relAllShopFlag === 0" @click="bindShopClick" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
									<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
									选择门店
								</div>
							</div>
							<div v-if="relAllShopFlag === 0" style="display: flex;align-items: center;height: 40px;">
								<div style="width:90px;text-align: right;">
									已选：
								</div>
								<div>{{shopText}}</div>
							</div>
							<div class="title-btn-box">
								<el-button class="btn" plain type="primary" size='small' @click="saveBatchShop">确认</el-button>
							</div>
						</div>
						<div class="table-box-sort" v-show="ruleForm.word === '5'">
							<el-table
								:stripe='true'
								size='mini'
								ref='multipleTable'
								class="grid-content"
								:data="ratioIds"
								max-height='400'
								border
							>
								<el-table-column
									label-class-name = "column-index"
									label="序号"
									type="index"
									width="70"
									align="center">
								</el-table-column>
								<el-table-column
									prop="productname"
									label="商品名称"
									width="170"
									align="center">
								</el-table-column>
								<el-table-column
									prop="productcode"
									label="商品编号"
									width="170"
									align="center">
								</el-table-column>
								<el-table-column
									prop="unit"
									label="辅助单位"
									align="center"
									min-width="100">
									<template slot-scope="scope">
										<div>{{scope.row.unit.assistUintName}}</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="unit"
									label="辅助单位换算系数"
									align="center"
									min-width="100">
									<template slot-scope="scope">
										<el-input type="number" size="mini" :disabled="!scope.row.useunitflag" v-model="scope.row.unit.ratio" @input="editRatio(scope.row)"></el-input>
									</template>
								</el-table-column>
								<el-table-column
									prop="unit"
									label="基础单位"
									align="center"
									min-width="100">
									<template slot-scope="scope">
										<div>{{scope.row.unit.baseUnitName}}</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="title-btn-box">
								<el-button class="btn" plain type="primary" size='small' @click="saveEditRatio">确认</el-button>
							</div>
						</div>
						<div v-if="ruleForm.word === '6'">
							<div style="display: flex;align-items: center;height: 40px;margin: 0px 20px;">
								<div style="width:90px;text-align: right;">
									可见状态：
								</div>
								<el-radio style="height: 20px;line-height: 20px;" v-model="visibleflag" :label="true">可见</el-radio>
								<el-radio style="height: 20px;line-height: 20px;" v-model="visibleflag" :label="false">不可见</el-radio>
							</div>
							<div style="height: 20px;line-height: 20px;margin-left:105px;font-size: 12px;margin-top: 10px;">
								*可见状态是控制该商品在可以销售的情况下，买家在小程序中无法主动进行检索、下单等，但是可以通过作为附属品，赠品提单
							</div>
							<div style="display: flex;height: 60px;align-items: center;justify-content: center;">
								<el-button size="mini" type="primary" plain @click='saveBatchVisibleflag'>确认</el-button>
							</div>
						</div>
						<div v-if="ruleForm.word === '7'">
							<div style="display:flex;align-items:center;height:40px;margin-right:20px;">
								<div style="width:110px;text-align: right;display: flex;align-items: center;">
									未登录时是否显示<span style="width:15px;flex-shrink:0">：</span>
								</div>
								<el-radio style="height: 20px;line-height: 20px;" v-model="loginShowFlag" :label="true">显示</el-radio>
								<el-radio style="height: 20px;line-height: 20px;" v-model="loginShowFlag" :label="false">不显示</el-radio>
							</div>
							<div style="height: 20px;line-height: 20px;margin-left:105px;font-size: 12px;margin-top: 10px;">
								*设置可见后，当买家小程序未登录时，在采购页显示该品项
							</div>
							<div style="display: flex;height: 60px;align-items: center;justify-content: center;">
								<el-button size="mini" type="primary" plain @click='saveloginShowFlag'>确认</el-button>
							</div>
						</div>
						<div v-if="ruleForm.word === '8'">
							<div style="display: flex;align-items: center;height: 40px;margin: 0px 20px;">
								<div style="width:90px;text-align: right;">
									运输方式：
								</div>
								<el-select v-model="mutiTransportMode" class="filter-input" size='small'>
									<el-option :value="1" label="常温运输"></el-option>
									<el-option :value="2" label="冷链运输"></el-option>
								</el-select>
							</div>
							<div style="display: flex;height: 60px;align-items: center;justify-content: center;">
								<el-button size="mini" type="primary" plain @click='saveTransportMode'>确认</el-button>
							</div>
						</div>
					</div>
				</el-form>
			</el-dialog>
			<el-dialog title="提示" class="dialog-title" :visible.sync="tipModal" width='400px' :close-on-click-modal="false">
			<div style="padding-bottom:20px;text-align: left;overflow:auto" v-for="item in tipData" :key="item">
				{{item}}
			</div>
		</el-dialog>

		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
		<BatchImportImg
			:visible.sync="showBatchImportImg"
			@success="batchImportImgSuccess"
			@error="batchImportImgError">
		</BatchImportImg>

	</div>
</template>

<script>
import Freight from '@/components/freight/freight.vue'
import bindModal from '@/components/storeSetting/saleableGoods/BindModal.vue'
import setMuti from '@/components/storeSetting/saleableGoods/setMuti.vue'
import ViewModal from '@/components/storeSetting/saleableGoods/ViewModal.vue'
import Search from '@/components/storeSetting/saleableGoods/Search.vue'
import bindShop from '@/components/bindShop/bindShop.vue'
import BatchImportImg from '@/components/storeSetting/saleableGoods/BatchImportImg.vue'
import vuedraggable from 'vuedraggable'
export default {
	name: 'storeBasicInfo',
	components: {
		Search,
		bindModal,
		ViewModal,
		setMuti,
		Freight,
		bindShop,
		BatchImportImg,
		vuedraggable
	},
	data () {
		return {
			tableTitle: [],
			showTableTitle: [],
			orginTableTitle: [
				{
					name: 'bbcname',
					text: '店铺级大类',
					isChoose: true
				},
				{
					name: 'sbcname',
					text: '店铺级小类',
					isChoose: true
				},
				{
					name: 'showflag',
					text: '未登录时是否显示',
					isChoose: true
				},
				{
					name: 'shopNames',
					text: '适用门店',
					isChoose: true
				},
				{
					name: 'productcode',
					text: '商品/规格',
					isChoose: true
				},
				{
					name: 'unit',
					text: '单位',
					isChoose: true
				},
				{
					name: 'code',
					text: '规格名称',
					isChoose: true
				},
				{
					name: 'price',
					text: '销售价',
					isChoose: true
				},
				{
					name: 'intervalCostPrice',
					text: '成本价',
					isChoose: true
				},
				{
					name: 'disabledflag',
					text: '启用状态',
					isChoose: true
				},
				{
					name: 'hiddenflag',
					text: '私密状态',
					isChoose: true
				},
				{
					name: 'visibleflag',
					text: '是否可见',
					isChoose: true
				}
			],
			mutiTransportMode: 1,
			visibleflag: true,
			orginSeqnumTable: [],
			shopText: '',
			chooseShop: [],
			shopDialog: false,
			relAllShopFlag: 1,
			orginData: [],
			freightType: 0,
			AuthorityList: {
				'02_0001_0001_00': false,
				'02_0001_0002_00': false,
				'02_0001_0003_00': false,
				'02_0001_0004_00': false,
				'02_0001_0005_00': false,
				'02_0001_0006_00': false,
				'02_0001_0007_00': false,
				'02_0001_0008_00': false,
				'02_0001_0009_00': false,
				'02_0001_0010_00': false
			},
			actualtimeinventoryflag: null,
			subtitle: '',
			subtitlecolour: '',
			predefineColors: [
				'#333333', '#4a4a4a', '#ffffff', '#d0021b', '#f5a623', '#f8e71c', '#8b572a', '#7ed321', '#417505', '#bd10e0', '#9013fe', '#4a90e2', '#50e3c2', '#b8e986', '#000000'
			],
			showSetMuit: false,
			showSetTitle: false,
			shopName: '',
			productId: '',
			goodsId: '',
			showBtn: false,
			editDisable: false,
			addDisable: false,
			bindModal: false,
			isShow: false,
			detailModal: false,
			isCheck: false,
			startModal: false,
			privateModal: false,
			showImgModal: false,
			showBatchSetting: false,
			startRadio: 0,
			privateRadio: 0,
			specImg: '',
			params: {
				shopIds: [],
				productName: '',
				productCode: '',
				bigTypeCategory: '0',
				smallTypeCategory: '0',
				matchname: '',
				page: 1,
				size: 20,
				disabledflag: -1,
				visibleflag: null,
				showflag: -1,
				usesystemfreightflag: null,
				hiddenflag: -1,
				orderBy: '',
				orderKey: ''
			},
			tableData: [],
			titleTableData: [],
			seqnumTable: [],
			tableHeight: '100%',
			total: 0,
			pid: [],
			titleIds: [],
			excelParams: {},
			bigcategoryview: 0,
			thirdcategoryview: 0,
			bigCategoryList: [],
			smallCategoryList: [],
			thirdCategoryList: [],
			ruleForm: {
				word: '1',
				bigTypeCategory: '',
				smallTypeCategory: '',
				thirdTypeCategory: ''
			},
			isTrue: true,
			tempflag: 0,
			matchbillcenterflag: false,
			showFlag: true,
			loginShowFlag: false,
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'productid',
				selectHandler: this.tableSelectUtilsHandler
			}),
			spceList: [],
			tipModal: false,
			tipData: [],
			showBatchImportImg: false,
			downloadUrl: '',
			stopFlag: false,
			ratioIds: [],
			updateRatioIds: [],
			costshowflag: 0,
			showSetting: false,
			allShow: false,
			isUpdate: false,
			tableBoxHeight: null
		}
	},
	created () {
		this.shopName = window.sessionStorage.getItem('shopName')
		this.params.shopid = sessionStorage.getItem('storeid')
		let params = sessionStorage.getItem('goodsParams')
		if (params) {
			this.params = JSON.parse(params)
		}
		this.getFreight()
		this.tableReload()
		this.getAuditShop()
		this.getAuthority('02_0001_0000_00')
		this.checkSmallCategory()
		this.$nextTick(() => {
			this.getTableTitle()
			this.tableBoxHeight = this.$refs.tableBox.offsetHeight - 20
			console.log(this.tableBoxHeight)
		})
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		},
		thirdCategoryEnabled () {
			return +this.bigcategoryview === 1 && +this.thirdcategoryview === 1
		}
	},
	methods: {
		checkAll () {
			let flag = true
			this.tableTitle.forEach(item => {
				flag = flag && item.isChoose
			})
			this.allShow = flag
		},
		allShowChange () {
			this.tableTitle.forEach(item => {
				item.isChoose = this.allShow
			})
		},
		reloadTableData () {
		},
		initTableTitle (data) {
			let list = JSON.parse(data)
			let selectArr = []
			let noSelectArr = []
			list.forEach(item => {
				if (item.isChoose) {
					selectArr.push(item)
				} else {
					noSelectArr.push(item)
				}
			})
			this.isUpdate = !this.isUpdate
			this.tableTitle = this.$fxUtils.deepClone([...selectArr, ...noSelectArr])
			this.showTableTitle = this.$fxUtils.deepClone(selectArr)
			this.checkAll()
		},
		getTableTitle () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/product/showInfo`
			}).then(res => {
				if (res.result) {
					if (res.data === null) {
						this.showTableTitle = this.$fxUtils.deepClone(this.orginTableTitle)
						this.tableTitle = this.$fxUtils.deepClone(this.orginTableTitle)
					} else {
						this.initTableTitle(res.data)
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveTable () {
			let params = {
				showproductinfo: JSON.stringify(this.tableTitle)
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/product/saveShowInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功')
					this.showSetting = false
					this.getTableTitle()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		clearTable () {
			let params = {
				showproductinfo: JSON.stringify(this.orginTableTitle)
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/product/saveShowInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功')
					this.showSetting = false
					this.getTableTitle()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		showSettingChange () {
			this.showSetting = !this.showSetting
			console.log(this.showSetting)
		},
		// 排序
		sortChangeHandle (data) {
			// console.log(data)
			if (data.order === null) {
				this.params.orderKey = ''
				this.params.orderBy = ''
			} else {
				this.params.orderKey = data.order === 'descending' ? 1 : 0
				let arr = ['价格', '可售', '启用', 'url', 'bbcname', 'sbcname', 'price', 'intervalCostPrice']
				this.params.orderBy = arr.findIndex((value) => {
					return value === data.prop
				})
			}
			this.tableReload()
		},
		copyHandle (data) {
			let params = {
				id: data.productid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/product/copy`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('复制成功！')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		copyClick (data) {
			this.$confirm('您确认要复制该商品吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.copyHandle(data)
			}).catch(() => {

			})
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		},
		bindShopClick () {
			this.shopDialog = true
		},
		cancelFreight () {
			this.showBatchSetting = false
		},
		getFreight () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/freight/detail/get`
			}).then(res => {
				if (res.result) {
					let list = res.data.freightDetailDTOList || []
					this.stopFlag = res.data.stopFlag
					this.freightType = res.data.freightType
					if (list.length > 0) {
						list.forEach(item => {
							let nameArr = item.areaname.split(',')
							item.provinces = item.provinces.split(',')
							item.showname = item.areaname
							if (nameArr.length > 20) {
								item.showname = nameArr.slice(0, 21).join(',') + '...'
							}
						})
					}
					this.orginData = list
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveFreight () {
			this.tableSelectUtils.clear()
			this.showBatchSetting = false
			this.tableReload()
		},
		tableSelectUtilsHandler (row) {
			return {
				productname: row.productname,
				productid: row.productid,
				spec: row.spec,
				productcode: row.productcode,
				unit: row.unit,
				useunitflag: row.useunitflag
			}
		},
		importExcel () {
			this.$router.push('importExcel')
		},
		openBatchImportImg () {
			this.showBatchImportImg = true
		},
		batchImportImgSuccess () {
			this.tableReload()
		},
		batchImportImgError (data) {
			this.tipData = data
			this.tipModal = true
		},
		// 是否开启小类
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.actualtimeinventoryflag = res.actualtimeinventoryflag
				this.bigcategoryview = res.bigcategoryview
				this.matchbillcenterflag = res.matchbillcenterflag === 1
				this.costshowflag = res.costshowflag
				if (res.thirdcategoryview !== undefined && res.thirdcategoryview !== null) {
					this.setThirdCategoryView(res.thirdcategoryview)
				} else {
					this.checkThirdCategory()
				}
			})
			// })
		},
		// 是否开启三级类别
		setThirdCategoryView (thirdcategoryview) {
			let enabled = +thirdcategoryview === 1 ? 1 : 0
			if (+this.bigcategoryview !== 1) {
				enabled = 0
			}
			this.thirdcategoryview = enabled
		},
		checkThirdCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/findallbasicinfo`
			}).then(res => {
				if (res.result) {
					this.setThirdCategoryView(res.data.thirdcategoryview || 0)
				} else {
					this.thirdcategoryview = 0
				}
			}).catch(() => {
				this.thirdcategoryview = 0
			})
		},
		// 批量设置切换
		wordChange (e) {
			if (e === '2') {
				this.ruleForm.word = '1'
				this.$confirm('确认关闭当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.ruleForm.word = '2'
				}).catch(() => {})
			} else if (e === '1') {
				this.ruleForm.word = '2'
				this.$confirm('确认关闭当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.ruleForm.word = '1'
				}).catch(() => {})
			}
		},
		getSeqnumTable () {
			let list = []
			this.ids.forEach(item => {
				list.push(item.productid)
			})
			let params = {
				ids: list.join(','),
				shopid: this.params.shopid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/getProductInfo4Seqnum`,
				data: params
			}).then(res => {
				if (res.result === true) {
					// this.tableSelectUtils.clear()
					this.seqnumTable = res.data
					this.orginSeqnumTable = JSON.parse(JSON.stringify(res.data))
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		numBlur (data) {
			if (data.seqnum === '' || data.seqnum === null) {
				data.seqnum = '0'
			}
		},
		numInput (data) {
			let seqnum = data.seqnum.replace(/[^\d-]/g, '')
			if (seqnum !== '' && seqnum !== null) {
				data.seqnum = seqnum
			} else {
				data.seqnum = ''
			}
		},
		// 规格悬停加粗
		specEnter (index, index1) {
			this.tableData[index].spec[index1].bold2 = true
		},
		specOut (index, index1) {
			this.tableData[index].spec[index1].bold2 = false
		},
		// 商品点击加粗
		goodsEnter (index, index1) {
			this.tableData[index].bold2 = true
		},
		goodsOut (index, index1) {
			this.tableData[index].bold2 = false
		},
		// 处理老数据
		getOldData () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/dealOldProductAttrType`
			}).then(res => {})
		},
		tableRowClassName ({ row, rowIndex }) {
			if (row.checked) {
				return 'check-row'
			}
			return ''
		},
		subtitleChange () {
			if (this.subtitle.match(/^[ ]*$/)) {
				this.subtitle = ''
			}
			this.subtitle = this.subtitle.replace(/['\\]/g, '')
		},
		subtitleChange1 (row) {
			if (row.subtitle.match(/^[ ]*$/)) {
				row.subtitle = ''
			}
			row.subtitle = this.subtitle.replace(/['\\]/g, '')
		},
		subtitlecolourChange1 (row) {
			if (row.subtitlecolour === null) {
				row.subtitlecolour = '#000000'
			}
		},
		delClick (data) {
			this.titleTableData.splice(data, 1)
			this.$message.success('移除成功')
		},
		mutiSave () {
			if (this.subtitle === '') {
				this.$message.error('请输入副标题')
				return false
			} else {
				let ids = this.titleIds
				let list = this.titleTableData
				if (ids.length > 0) {
					for (let i = 0; i < ids.length; i++) {
						for (let j = 0; j < list.length; j++) {
							if (list[j].id === ids[i]) {
								list[j].subtitle = this.subtitle
								break
							}
						}
					}
				} else {
					for (let i = 0; i < list.length; i++) {
						list[i].subtitle = this.subtitle
					}
				}
				this.titleTableData = list
			}
		},
		subtitlecolourChange () {
			if (this.subtitlecolour === null) {
				this.subtitlecolour = '#000000'
			}
			let ids = this.titleIds
			let list = this.titleTableData
			if (ids.length > 0) {
				for (let i = 0; i < ids.length; i++) {
					for (let j = 0; j < list.length; j++) {
						if (list[j].id === ids[i]) {
							list[j].subtitlecolour = this.subtitlecolour
							break
						}
					}
				}
			} else {
				for (let i = 0; i < list.length; i++) {
					list[i].subtitlecolour = this.subtitlecolour
				}
			}
			this.titleTableData = list
		},
		addCellClass (row) {
			if (row.columnIndex === 3) {
				return 'cellClass'
			}
		},
		clearTitle () {
			let list1 = []
			this.ids.forEach(item => {
				list1.push(item.productid)
			})
			let list = list1
			let params = []
			for (let i = 0; i < list.length; i++) {
				params.push({
					id: list[i]
				})
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/subtitles/clean`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					this.$message.success('操作成功')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		clearTitleClick () {
			if (this.ids.length === 0) {
				this.$message.error('请至少勾选一个商品！')
				return false
			}
			this.$confirm('是否确认批量清空副标题？一经操作无法复原', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.clearTitle()
			})
		},
		titleCancel () {
			this.showSetTitle = false
		},
		titleSave () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/subtitles/save`,
				data: this.titleTableData
			}).then(res => {
				if (res.result === true) {
					this.$message.success('保存成功')
					this.showSetTitle = false
					this.tableReload()
				} else {
					this.$message.error(res.msg)
					this.errorEvent(res.data)
				}
			})
		},
		errorEvent (data) {
			let ids = []
			for (let i = 0; i < data.length; i++) {
				ids.push(data[i].id)
			}
			let id = ids.join(',')
			let params = {
				ids: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/subtitle/list`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let list = res.data
					this.titleTableData = list
					this.subtitlecolour = ''
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSelectionTitleChange (data) {
			let ids = []
			for (let i = 0; i < data.length; i++) {
				ids.push(data[i].id)
			}
			this.titleIds = ids
		},
		setTitle () {
			if (this.ids.length === 0) {
				this.$message.error('请至少勾选一个商品！')
				return false
			}
			let list = []
			this.ids.forEach(item => {
				list.push(item.productid)
			})
			let id = list.join(',')
			let params = {
				ids: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/subtitle/list`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					this.titleTableData = res.data
					this.showSetTitle = true
					this.subtitle = ''
					this.subtitlecolour = ''
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/product/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			let list = []
			this.ids.forEach(item => {
				list.push(item.productid)
			})
			this.params.ids = list.join(',')
			req.send(JSON.stringify(this.params))
		},
		download (blobUrl) {
			var date = new Date()
			var year = date.getFullYear()
			var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1) + ''
			var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ''
			var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() + ''
			var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds() + ''
			let curDate = year + month + day + hour + min + seconds
			const a = document.createElement('a')
			a.style.display = 'none'
			a.download = '可售商品档案(' + curDate + ').xlsx'
			a.href = blobUrl
			a.click()
		},
		cancelSetMuit () {
			this.showSetMuit = false
			this.tableReload()
		},
		setMuit () {
			this.showSetMuit = true
		},
		rowClick (row, column, event) {
			this.getDetail(row)
		},
		isClose () {
			if (this.$refs.viewModal.returnChange()) {
				this.detailModal = true
				this.$confirm('当前页面未保存，是否确认关闭？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.detailModal = false
				}).catch(() => {})
			} else {
				this.tableReload()
				this.detailModal = false
			}
		},
		getAuditShop () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getAuditShopCount`
			}).then(res => {
				if (res.result) {
					if (res.data.auditShopCount === 0) {
						this.isCheck = false
					} else {
						this.isCheck = true
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		startStatus () {
			if (this.ids.length === 0) {
				this.$message.warning('请勾选商品！')
				return false
			}
			this.startRadio = 0
			this.startModal = true
		},
		startClose () {
			this.startModal = false
			this.startRadio = 0
		},
		startSave () {
			let list = []
			let nameList = []

			this.ids.forEach(item => {
				list.push(item.productid)
				nameList.push(item.productname)
			})

			let changeData = {
				pre: {
					batchSelect3: {
					}
				},
				cur: {
					batchSelect3: {
						name: nameList.join(','),
						status: this.startRadio === 0 ? '启用' : '禁用'
					}

				}
			}
			const logger = this.$fxLogger.createInfo('goods.saleable_goods.update', changeData)


			let params = {
				productIds: list,
				disabledflag: this.startRadio
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/update/disabledflag`,
				data: params,
				logger
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					if (this.startRadio === 0) {
						this.$message.success('勾选商品启用状态更换成功！')
					} else {
						this.$message.success('勾选商品禁用状态更换成功！')
					}
					this.startModal = false
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		privateSave () {
			let list = []
			let nameList = []

			this.ids.forEach(item => {
				list.push(item.productid)
				nameList.push(item.productname)
			})

			let changeData = {
				pre: {
					batchSelect4: {
					}
				},
				cur: {
					batchSelect4: {
						name: nameList.join(','),
						status: this.privateRadio === 1 ? '私密' : '公开'
					}

				}
			}
			const logger = this.$fxLogger.createInfo('goods.saleable_goods.update', changeData)
			let params = {
				productIds: list,
				hiddenflag: this.privateRadio
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/update/hiddenflag`,
				data: params,
				logger
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					if (this.privateRadio === 0) {
						this.$message.success('勾选商品公开状态更换成功！')
					} else {
						this.$message.success('勾选商品私密状态更换成功！')
					}
					this.privateModal = false
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		privateStatus () {
			if (this.ids.length === 0) {
				this.$message.warning('请勾选商品！')
				return false
			}
			this.privateRadio = 0
			this.privateModal = true
		},
		privateClose () {
			this.privateModal = false
			this.privateRadio = 0
		},
		statusChange (data) {
			if (this.ids.length === 0) {
				this.$message.warning('请至少勾选一个商品！')
				return false
			}
			let list = []
			this.ids.forEach(item => {
				list.push(item.productid)
			})
			let id = list.join(',')
			let params = {
				ids: id,
				stackFlag: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/relation/updateGoodsStackFlag`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					if (data === 0) {
						this.$message.success('上架成功')
					} else {
						this.$message.success('下架成功')
					}
					this.tableReload()
				} else {
					if (res.code === 999) {
						let name = []
						res.data.forEach(e => {
							name.push(e.info)
						})
						this.$alert('［' + name.join(',') + '］没有店铺类别,修改上下架状态失败', '提示', {
							confirmButtonText: '确定',
							type: 'warning',
							callback: action => {
							}
						})
						// this.$message.error('［' + name.join(',') + '］没有店铺类别,修改上下架状态失败')
					} else {
						this.$message.error(res.msg)
					}
				}
			})
		},
		cancel (data) {
			this.bindModal = data
			this.isShow = data
			this.tableReload()
		},
		addClick () {
			window.sessionStorage.removeItem('productid')
			this.$router.push({
				path: 'newProduct',
				query: { isAdd: true, from: 'saleableGoods' }
			})
		},
		addPackageClick () {
			window.sessionStorage.removeItem('productid')
			this.$router.push({
				path: 'newProduct',
				query: { producttype: true, isAdd: true, from: 'saleableGoods' }
			})
		},
		cancelClick () {
			this.bindModal = false
			this.isShow = false
		},
		handleSizeChange (val) {
			this.params.size = val
			window.sessionStorage.removeItem('goodsParams')
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.params.page = val
			window.sessionStorage.removeItem('goodsParams')
			this.tableReload()
		},
		getTableDataHandle (data) {
			this.tableSelectUtils.clear()
			this.tableData = data.recordList
			this.total = data.recordCount
		},
		getParamsData (data) {
			this.params = data
			let excelParams = {
				id: 0,
				shopIds: this.params.shopIds,
				hiddenFlag: -1,
				stackFlag: this.params.stackFlag,
				visibleflag: this.params.visibleflag,
				goodsName: this.params.goodsName,
				freightTemplateid: this.params.freightTemplateid,
				subtitle: this.params.subtitle,
				bcId: this.params.bcId,
				scId: this.params.scId,
				saleState: this.params.saleState,
				auditState: this.params.auditState,
				matchname: this.params.matchname,
				usesystemfreightflag: this.params.usesystemfreightflag,
				producttype: this.params.producttype,
				comFlag: 0,
				sourceflag: -1,
				unitFlag: -1
			}
			this.excelParams = excelParams
		},
		handleSelectionChange (value) {
			this.tableSelectUtils.selectToggle(this.tableData, value)
			this.tableData.filter(e => {
				if (value.indexOf(e) > -1) {
					e.checked = true
				} else {
					e.checked = false
				}
			})
		},
		// 查看规格图片
		lookSpecImg (url) {
			this.showImgModal = true
			this.specImg = url
		},
		// 折叠规格
		showFold (index) {
			this.tableData[index].showFlag = !this.tableData[index].showFlag
		},
		tableReload () {
			let excelParams = {
				subtitle: this.params.subtitle,
				visibleflag: this.params.visibleflag,
				freightTemplateid: this.params.freightTemplateid,
				producttype: this.params.producttype,
				id: 0,
				shopIds: this.params.shopIds,
				hiddenFlag: -1,
				stackFlag: 2,
				goodsName: this.params.goodsName,
				bcId: this.params.bcId,
				scId: this.params.scId,
				saleState: 2,
				auditState: 4,
				comFlag: 0,
				sourceflag: -1,
				unitFlag: -1
			}
			this.excelParams = excelParams
			// this.params.showflag = this.params.loginflag
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/get/productlist`,
				data: this.params
			}).then(res => {
				if (res.recordCount !== 0) {
					res.recordList.forEach(e => {
						if (e.commpressflag) {
							if (e.url) {
								e.url = this.$fxUtils.changeImgSrc(e.url, 'big')
							}
						}
						if (this.showFlag) {
							e.showFlag = false
						} else {
							e.showFlag = true
						}
						e.bold = false
						e.bold2 = false
						e.spec.forEach(item => {
							item.bold = false
							item.bold2 = false
							item.price = +item.price < 0 ? '' : item.price
						})
					})
				}
				this.tableData = res.recordList
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
				})
				this.total = res.recordCount
				this.tempflag = res.tempflag

				let params = sessionStorage.getItem('goodsParams')
				if (params) {
					let scrollTopValue = JSON.parse(params).scrollTopValue
					let tableContainer = document.querySelector('.el-table__body-wrapper')
					this.$nextTick(() => {
						tableContainer.scrollTop = scrollTopValue
						this.$refs.table.doLayout()
					})
				}
			})
		},
		deleteList () {
			if (this.ids.length === 0) {
				this.$message.warning('请至少勾选一个商品！')
				return false
			}
			this.$confirm('是否删除已勾选【' + this.ids.length + '】个商品和提成规则？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let list = []
				let nameList = []
				this.ids.forEach(item => {
					list.push(item.productid)
					nameList.push('商品名称：' + item.productname + '商品编号' + item.productcode)
				})
				let params = {
					productIds: list
				}
				const logger = this.$fxLogger.createInfo('goods.saleable_goods.delete', { name: nameList.join(',') })
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/product/del`,
					data: params,
					logger
				}).then(res => {
					if (res.result) {
						this.tableSelectUtils.clear()
						this.$message.success('商品删除成功！')
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		deleteClick (data) {
			this.$confirm('是否删除【' + data.productname + '】和提成规则？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let name = '商品名称：' + data.productname + '商品编号' + data.productcode
				const logger = this.$fxLogger.createInfo('goods.saleable_goods.delete', { name: name })
				let params = {
					productIds: [data.productid]
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/product/del`,
					data: params,
					logger
				}).then(res => {
					if (res.result) {
						this.$message.success('商品删除成功！')
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		getDetail (data) {
			let tableContainer = document.querySelector('.el-table__body-wrapper')
			let scrollTopValue = tableContainer.scrollTop
			let params = this.params
			params.scrollTopValue = scrollTopValue
			window.sessionStorage.setItem('goodsParams', JSON.stringify(params))
			window.sessionStorage.setItem('productid', data.productid)
			let producttype = data.producttype
			if (producttype === 1) {
				producttype = true
			} else {
				producttype = false
			}
			this.$router.push({
				path: 'newProduct',
				query: { producttype, isAdd: false, from: 'saleableGoods' }
			})
		},
		batchSetting () {
			if (this.ids.length === 0) {
				this.$message.warning('请至少勾选一个商品！')
				return false
			}
			this.ids.forEach(item => {
				if (!item.useunitflag) {
					item.unit = {}
				}
			})
			this.ratioIds = JSON.parse(JSON.stringify(this.ids))
			this.initSpecId()
			this.ruleForm.word = '1'
			this.shopText = ''
			this.relAllShopFlag = 1
			this.visibleflag = true
			this.chooseShop = []
			this.showBatchSetting = true
			this.checkThirdCategory()
			this.getBigCategory()
			this.getSeqnumTable()
		},
		initSpecId () {
			let list = this.ids
			let spceList = []
			list.forEach(item => {
				item.spec.forEach(specItem => {
					spceList.push(specItem.specid)
				})
			})
			this.spceList = spceList
		},
		cancelBatchSetting () {
			this.$confirm('确认关闭当前页面？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.showBatchSetting = false
				this.loginShowFlag = false
				this.ruleForm.word = '1'
			}).catch(() => {})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bigCategoryList = res.data.filter(item => !item.disabledflag)
					this.ruleForm.bigTypeCategory = this.bigCategoryList[0].bc_id
				}
				if (this.bigcategoryview === 1) {
					this.smallCategoryList = []
					this.getSmalCategory()
				}
			})
		},
		getSmalCategory () {
			return new Promise((resolve, reject) => {
				let params = {
					pid: this.ruleForm.bigTypeCategory
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
					data: params
				}).then(res => {
					if (res.result) {
						this.ruleForm.smallTypeCategory = res.data[0].id
						this.smallCategoryList = res.data.filter(item => !item.disabledflag)
						if (this.thirdCategoryEnabled) {
							this.ruleForm.thirdTypeCategory = ''
							this.getThirdCategory()
						}
						resolve(res)
					}
				})
			})
		},
		getThirdCategory () {
			if (!this.ruleForm.smallTypeCategory) {
				this.thirdCategoryList = []
				return
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/getThirdCategory`,
				data: { pid: this.ruleForm.smallTypeCategory }
			}).then(res => {
				if (res.result) {
					this.thirdCategoryList = (res.data || []).filter(item => !item.disabledflag)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		thirdCategoryVisibleChange (visible) {
			if (!visible) return
			if (!this.ruleForm.smallTypeCategory) {
				this.$message.warning('请先选择店铺小类')
				this.$nextTick(() => {
					this.$refs.thirdCategorySelect && this.$refs.thirdCategorySelect.blur()
				})
				return
			}
			this.getThirdCategory()
		},
		seqBigCategoryChange (row) {
			if (this.bigcategoryview === 1) {
				let params = {
					pid: row.bigTypeCategory
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
					data: params
				}).then(res => {
					if (res.result) {
						row.smallTypeCategory = res.data[0].id
						row.smallCategoriesList = res.data.filter(item => !item.disabledflag)
					}
				})
			}
		},
		bigCategoryChange (data) {
			this.ruleForm.smallTypeCategory = ''
			this.ruleForm.thirdTypeCategory = ''
			this.thirdCategoryList = []
			this.categoryChange(data)
			if (this.bigcategoryview === 1) {
				this.smallCategoryList = []
				this.getSmalCategory()
			}
		},
		smallCategoryChange (data) {
			this.ruleForm.thirdTypeCategory = ''
			this.thirdCategoryList = []
			if (this.thirdCategoryEnabled && this.ruleForm.smallTypeCategory) {
				this.getThirdCategory()
			}
			this.categoryChange(data)
		},
		categoryChange (formName) {
			if (this.ruleForm.bigTypeCategory === '' || (this.bigcategoryview === 1 && this.ruleForm.smallTypeCategory === '')) {
				this.isTrue = true
			} else {
				this.isTrue = false
			}
			this.$refs[formName].validateField('category', (error) => {
				if (!error) {
				} else {
					return false
				}
			})
		},
		checkBig (data, list) {
			let name = ''
			list.forEach(item => {
				if (data === item.bc_id) {
					name = item.bc_name
				}
			})
			return name
		},
		checkSmall (data, list) {
			let name = ''
			list.forEach(item => {
				if (data === item.id) {
					name = item.name
				}
			})
			return name
		},
		checkSeq () {
			let orgin = this.orginSeqnumTable
			let now = this.seqnumTable
			let list = []
			for (let i = 0; i < orgin.length; i++) {
				if (+orgin[i].seqnum !== +now[i].seqnum || orgin[i].bigTypeCategory !== now[i].bigTypeCategory || orgin[i].smallTypeCategory !== now[i].smallTypeCategory) {
					let row = ''
					if (this.bigcategoryview === 1) {
						row = '【商品名称：' + orgin[i].productname + '】【商品顺序号：' + orgin[i].seqnum + '】【商品大类：' + this.checkBig(orgin[i].bigTypeCategory, orgin[i].bigCategoriesList) + '】【商品小类：' + this.checkSmall(orgin[i].smallTypeCategory, orgin[i].smallCategoriesList) +
						'】修改为【商品顺序号：' + now[i].seqnum + '】【商品大类：' + this.checkBig(now[i].bigTypeCategory, now[i].bigCategoriesList) + '】【商品小类：' + this.checkSmall(now[i].smallTypeCategory, now[i].smallCategoriesList) + '】'
					} else {
						row = '【商品名称：' + orgin[i].productname + '】【商品顺序号：' + orgin[i].seqnum + '】【商品大类：' + this.checkBig(orgin[i].bigTypeCategory, orgin[i].bigCategoriesList) + '】】修改为【商品顺序号：' + now[i].seqnum + '】【商品大类：' + this.checkBig(now[i].bigTypeCategory, now[i].bigCategoriesList) + '】'
					}

					list.push(row)
				}
			}
			return list
		},
		saveSecSetting () {
			let changeData = null
			let logger = null
			let nameList = this.checkSeq()
			if (nameList.length > 0) {
				changeData = {
					pre: {
						batchSelect5: {
						}
					},
					cur: {
						batchSelect5: {
							name: nameList.join(',')
						}

					}
				}
				logger = this.$fxLogger.createInfo('goods.saleable_goods.update', changeData)
			}
			let params = {
				productSeqnumDTOS: this.seqnumTable
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/update/seqnum`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.showBatchSetting = false
					this.ruleForm.bigTypeCategory = ''
					this.ruleForm.smallTypeCategory = ''
					this.ruleForm.thirdTypeCategory = ''
					this.thirdCategoryList = []
					this.ruleForm.word = '1'
					this.tableSelectUtils.clear()
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveBatchVisibleflag () {
			let list = []
			let nameList = []
			this.ids.forEach(item => {
				list.push(item.productid)
				nameList.push(item.productname)
			})

			let changeData = {
				pre: {
					batchSelect6: {
					}
				},
				cur: {
					batchSelect6: {
						name: nameList.join(','),
						visibleflag: this.visibleflag ? '可见' : '不可见'
					}
				}
			}
			const logger = this.$fxLogger.createInfo('goods.saleable_goods.update', changeData)
			let params = {
				productIds: list,
				visibleflag: this.visibleflag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/update/visibleflag`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('批量设置可见状态成功！')
					this.showBatchSetting = false
					this.tableSelectUtils.clear()
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveTransportMode () {
			let list = []
			let nameList = []
			this.ids.forEach(item => {
				list.push(item.productid)
				nameList.push(item.productname)
			})
			let changeData = {
				pre: {
					batchSelect8: {
					}
				},
				cur: {
					batchSelect8: {
						name: nameList.join(','),
						mutiTransportMode: this.mutiTransportMode === 1 ? '常温运输' : '冷链运输'
					}
				}
			}
			const logger = this.$fxLogger.createInfo('goods.saleable_goods.update', changeData)
			let params = {
				productIds: list,
				transportMode: this.mutiTransportMode
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/update/transportMode`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('批量设置成功！')
					this.showBatchSetting = false
					this.loginShowFlag = false
					this.tableSelectUtils.clear()
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveloginShowFlag () {
			let list = []
			let nameList = []
			this.ids.forEach(item => {
				list.push(item.productid)
				nameList.push(item.productname)
			})

			let changeData = {
				pre: {
					batchSelect7: {
					}
				},
				cur: {
					batchSelect7: {
						name: nameList.join(','),
						loginShowFlag: this.loginShowFlag ? '显示' : '不显示'
					}
				}
			}
			const logger = this.$fxLogger.createInfo('goods.saleable_goods.update', changeData)
			let params = {
				productIds: list,
				showflag: this.loginShowFlag ? 1 : 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/update/showflag`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('批量设置成功！')
					this.showBatchSetting = false
					this.loginShowFlag = false
					this.tableSelectUtils.clear()
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveBatchShop () {
			if (this.chooseShop.length === 0 && this.relAllShopFlag === 0) {
				this.$message.error('请选择适用店铺')
				return false
			}
			let list = []
			let nameList = []
			this.ids.forEach(item => {
				list.push(item.productid)
				nameList.push(item.productname)
			})

			let changeData = {
				pre: {
					batchSelect2: {
					}
				},
				cur: {
					batchSelect2: {
						name: nameList.join(','),
						shopname: this.relAllShopFlag === 1 ? '全部门店' : this.shopText
					}

				}
			}
			const logger = this.$fxLogger.createInfo('goods.saleable_goods.update', changeData)

			let params = {
				productIds: list,
				shopIds: this.chooseShop,
				relAllShopFlag: this.relAllShopFlag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/saveRelProductAttrplanShop`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('批量设置适用门店成功！')
					this.showBatchSetting = false
					this.tableSelectUtils.clear()
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveBatchSetting () {
			if (this.bigcategoryview === 1 && !this.ruleForm.smallTypeCategory) {
				this.$message.error('请选择店铺级小类')
				return false
			}
			let list = []
			let nameList = []
			this.ids.forEach(item => {
				list.push(item.productid)
				nameList.push(item.productname)
			})
			let bigCategoryName = ''
			let smallCategoryName = ''
			let thirdCategoryName = ''
			this.bigCategoryList.forEach(item => {
				if (item.bc_id === this.ruleForm.bigTypeCategory) {
					bigCategoryName = item.bc_name
				}
			})
			this.smallCategoryList.forEach(item => {
				if (item.id === this.ruleForm.smallTypeCategory) {
					smallCategoryName = item.name
				}
			})
			this.thirdCategoryList.forEach(item => {
				if (item.id === this.ruleForm.thirdTypeCategory) {
					thirdCategoryName = item.name
				}
			})
			let changeData = {
				pre: {
					batchSelect1: {
					}
				},
				cur: {
					batchSelect1: {
						name: nameList.join(','),
						bigCategoryName: bigCategoryName,
						smallCategoryName: this.ruleForm.smallTypeCategory ? smallCategoryName : null,
						thirdCategoryName: this.thirdCategoryEnabled && this.ruleForm.thirdTypeCategory ? thirdCategoryName : null
					}

				}
			}
			const logger = this.$fxLogger.createInfo('goods.saleable_goods.update', changeData)

			let params = {
				bigTypeCategory: this.ruleForm.bigTypeCategory,
				smallTypeCategory: this.ruleForm.smallTypeCategory ? this.ruleForm.smallTypeCategory : '0',
				productIds: list
			}
			if (this.thirdCategoryEnabled) {
				params.thirdTypeCategory = this.ruleForm.thirdTypeCategory ? this.ruleForm.thirdTypeCategory : '0'
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/update/category`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('批量修改店铺级分类成功！')
					this.showBatchSetting = false
					this.ruleForm.bigTypeCategory = ''
					this.ruleForm.smallTypeCategory = ''
					this.ruleForm.thirdTypeCategory = ''
					this.thirdCategoryList = []
					this.ruleForm.word = '1'
					this.tableSelectUtils.clear()
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		renderHeader (h, { column, $index }) {
			return h(
				'div', {
					class: 'header-div'
				},
				[
					h('div', {
						class: 'showFlag showFlag1',
						on: {
							'click': ($index) => {
								this.handleAddItem($index)
							}
						}
					}, this.showFlag ? '+' : '-'),
					h('span', '商品信息'),
					h(
						'el-tooltip',
						{
							props: {
								effect: 'dark',
								content: '按商品创建时间排序',
								placement: 'top'
							}
						},
						[
							h('i', {
								class: 'el-icon-warning-outline',
								style: `color:${this.$fxPrimaryColor};margin-left:5px;`
							})
						]
					)
				]
			)
		},
		handleAddItem (event) {
			event.stopPropagation()
			if (this.tableData) {
				this.tableData.forEach((item, index) => {
					if (this.showFlag) {
						this.tableData[index].showFlag = true
					} else {
						this.tableData[index].showFlag = false
					}
				})
			}
			this.showFlag = !this.showFlag
		},
		formateIntervalPrice (val) {
			if (val) {
				let arr = val.split('～')
				if (arr[0] === arr[1]) {
					return arr[0]
				} else {
					return val
				}
			}
		},
		importPriceExcel () {
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		getFile (e) {
			this.uploadGoodsHandle()
			this.$refs.file.value = ''
		},
		uploadGoodsHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/product/price/importExcel`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.tableData = res.data
						this.$message.success('导入成功！')
						this.tableReload()
					} else {
						this.tipData = res.data
						this.tipModal = true
					}
				})
			})
		},
		downloadFile () {
			const that = this
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQNVShop}/productprice/importExcel/template/url`
			}).then(res => {
				this.downloadUrl = res.data + '?timestamp=' + new Date().getTime()
				setTimeout(function () {
					that.$refs.download.dispatchEvent(new MouseEvent('click'))
				}, 500)
			})
		},
		editRatio (row) {
			row.unit.ratio = '' + row.unit.ratio
			row.unit.ratio = row.unit.ratio.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.unit.ratio = row.unit.ratio.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.unit.ratio = row.unit.ratio.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.unit.ratio = row.unit.ratio.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			row.unit.ratio = row.unit.ratio.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
		},
		checkRatio () {
			return new Promise((resolve, reject) => {
				this.updateRatioIds = this.ratioIds.filter(item => {
					return item.unit.assisId
				})
				for (var i = 0; i < this.updateRatioIds.length; i++) {
					if (this.updateRatioIds[i].unit.ratio === '') {
						this.$message.error(`${this.updateRatioIds[i].productname}的换算数值不能为空！`)
						return false
					} else if (this.updateRatioIds[i].unit.ratio !== '' && +this.updateRatioIds[i].unit.ratio < 1) {
						this.$message.error(`${this.updateRatioIds[i].productname}的换算数值必须大于等于1！`)
						return false
					}
				}
				resolve()
			})
		},
		batchSetAssistUnitRatio () {
			let params = this.updateRatioIds.map(e => {
				return {
					id: e.unit.assisId,
					productName: e.productname,
					ratio: +e.unit.ratio
				}
			})
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/batchSetAssistUnitRatio`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('批量设置辅助单位换算系数成功！')
					this.tableSelectUtils.clear()
					this.showBatchSetting = false
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveEditRatio () {
			this.checkRatio().then(() => {
				this.batchSetAssistUnitRatio()
			})
		},
		checkPrice (item, name) {
			item[name] = item[name].replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			item[name] = item[name].replace(/^\./g, '')// 验证第一个字符是数字而不是
			item[name] = item[name].replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			item[name] = item[name].replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			item[name] = item[name].replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入一个小数
		},
		priceChange (item) {
			if (item.price === '' || item.price === undefined || +item.price < 0) {
				item.price = ''
			}
			if (+item.price > 999999.99) {
				item.price = 999999.99
			}
		},
		priceChangeSubmit (item, row) {
			let params = {
				pId: row.productid,
				paId: item.specid,
				spePrice: +item.price || -1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/updateprice`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('销售价修改成功！')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.fx-big-btn1{
	width:120px;
}
.clear-box{
	width:100%;
	height:150px;
}
.spec-bold {
	font-weight: bold
}
.table-box-sort {
	// height: auto;
	// max-height: 400px
}
.store-basic-info {
	display: flex;
	min-width: 730px;
	width: 100%;
	flex-direction: column;
	height: 100%;
	.name-box{
		height :60px;
		line-height :60px;
		text-align :left;
		padding-left :10px;
		border-bottom 1px solid #dce2fd
		.input-box{
			margin-left :10px;
			overflow-x :hidden
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:150px;
				margin-right:10px;
			}
		}
	}
	.store-basic-header {
		border-bottom: 1px solid #dce2fd;
		height:78px;
		line-height: 78px;
		font-size: 20px;
		p {
			height: 100%
			box-sizing:border-box
			border-bottom: 3px solid var(--fx-primary-color);
			float left
		}
	}
	.features-btn-box {
		height:40px;
		text-align left
		padding :10px;
		border-top: 1px solid #dce2fd;
		display flex
		justify-content: space-between;
		.batch-register-btn{
			cursor :pointer;
			color: var(--fx-primary-color);
			font-size: 12px;
			margin-left: 20px;
			display: flex;
			height: 32px;
			justify-content: center;
			align-items: center;
		}
		.excel-icon {
			display inline-block
			height 20px
			width 20px
			background-repeat no-repeat
			background-position center
			&.import-excel-icon {
				background-image: url('~images/icon/import-excel-icon.png')
			}
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
	}
	.table-box {
		flex:1
		// padding-bottom :10px;
		// display: flex;
		// flex-direction: column;
		.goods-table.grid-content {
			font-size: 14px;
			color: #333;
		}
	}
	.table-div{
		display :flex;
		flex-direction :column;
		flex: 1;
		overflow: hidden
		.goods-table-info {
			padding: 0 10px !important
			display: flex;
			img {
				flex-shrink: 0
			}
			.goods-table-fold {
				display: flex;
				align-items: center;
				margin-right: 10px;
				.showFlag {
					display: inline-block;
					width: 15px;
					height: 15px;
					line-height: 15px;
					text-align: center;
					color: #fff;
					background-color: var(--fx-primary-color);
					cursor: pointer;
					font-weight: bold;
					font-size: 14px;
				}
			}
			.goods-table-name {
				color: #333;
				display: flex;
				align-items: center;
				margin-left: 10px;
				white-space: pre-wrap
			}
		}
		.goods-table-spec {
			&>div {
				height: 28px;
				line-height: 28px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				&.spec-blue {
					color: var(--fx-primary-color);
					span {
						border: 1px solid var(--fx-primary-color);
					}
				}
				img {
					display: inline-block;
					width: 12px;
					height: 12px;
					cursor: pointer;
					margin-left: 5px;
				}
				span {
					display: inline-block;
					border: 1px solid #ccc;
					border-radius: 2px;
					width: 30px;
					height: 16px;
					text-align: center;
					line-height: 18px;
					margin-right: 5px;
					font-size: 12px;
				}
			}
			&.goods-table-spec2>div{
				text-align: left;
				padding-left: 15px;
			}
			/deep/.el-input__inner {
				text-align: center;
			}
		}
		.goods-table-qita {
			&>div {
				height: 28px;
				line-height: 28px;
			}
		}
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}

}

.title-input{
	width :400px;
	margin-right:10px
}
.setTitle-box{
	width:100%;
	height:440px;
	.title-select-box{
		width:100%;
		height:50px;
		border-top:1px solid #DEE3FE;
		display:flex;
		flex-direction: row;
		align-items: center;
		justify-content:space-between
		div{
			display:flex;
			flex-direction: row;
			align-items: center;
		}
	}
	.title-table-box{
		height:350px
	}
}
	.title-btn-box{
		height:40px;
		padding:10px;
		box-sizing:border-box;
		text-align:center
		.btn{
			width:130px;
		}
	}
	.radio-box {
		display: block;
		margin: 0 0 10px 50px;
	}
	.batchSetBox {
		span {
			display: inline-block;
			width: 90px;
			text-align: right;
		}
		.input-box {
			margin: 10px 20px;
		}
	}
	.setting-box{
		position: absolute;
		top: 36px;
		right: -20px;
		width: 200px;
		z-index: 99;
		display: flex;
		background-color: #fff;
		flex-direction: column;
		border: 1px solid #eee;
		padding: 0 10px;
	}
	.setting-title-box{
		height: 40px;
		display: flex;
		flex-shrink: 1;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid #eee
	}
	.setting-container-box{
		flex: 1;
		overflow-y: auto
	}
	.setting-row{
		display: flex;
		flex-direction: row;
		align-items: center;
		height: 36px
	}
</style>
<style lang="stylus">
.cell{
	padding: 0 !important
}
.btn-box{
	display:flex;
	flex-direction:row;
	align-items :center;
	justify-content: center;
	cursor: pointer;
	color:var(--fx-primary-color);
	img{
		width:20px;
		height:20px;
		margin-right:4px;
	}
}
.el-table-column--selection {
	.cell{
		padding-left: 0px !important;
		padding-right: 0px !important;
	}
}
	.el-table .check-row {
		background: #F3F7FF;
	}
.cellClass {
	.cell{
		display:flex;
		flex-direction:row;
		align-items:center;
		justify-content:center
	}
}
.store-basic-info {
	.el-dialog__body {
		padding-top: 10px
	}
	.detail-dialog-title {
		.el-dialog__header {
			display: none
		}
		.el-dialog__title {
			padding-left 10px
			border: none
		}
	}
}
.header-div {
	line-height: 15px;
	display: inline-block;
}
.showFlag {
	display: inline-block;
	float: left;
	width: 15px;
	height: 15px;
	line-height: 15px;
	text-align: center;
	color: #fff;
	background-color: var(--fx-primary-color);
	cursor: pointer;
	font-weight: bold;
	font-size: 14px;
}
.showFlag.showFlag1 {
	position: absolute;
    left: 10px
}
</style>
